import request from "@/utils/request";

const SKILLHUB_AGENT_PREFIX = "/skillhub/agent/skills";
const SKILLHUB_CONSOLE_PREFIX = "/skillhub/console/skills";
const SKILLHUB_ADMIN_PREFIX = "/skillhub/admin/audits";

export function skillPage(params) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/page`,
    method: "post",
    data: params,
  });
}

export function skillList(params) {
  return request({
    url: SKILLHUB_AGENT_PREFIX,
    method: "get",
    params,
  });
}

export function skillDetail(skillUuid) {
  return request({
    url: `${SKILLHUB_AGENT_PREFIX}/${skillUuid}`,
    method: "get",
  });
}

export function skillAggregateDetail(skillUuid, params) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/detail`,
    method: "get",
    params,
  });
}

export function skillContent(skillUuid) {
  return request({
    url: `${SKILLHUB_AGENT_PREFIX}/${skillUuid}/content`,
    method: "get",
  });
}

export function skillMetadata(skillUuid) {
  return request({
    url: `${SKILLHUB_AGENT_PREFIX}/${skillUuid}/metadata`,
    method: "get",
  });
}

export function skillVersions(skillUuid) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions`,
    method: "get",
  });
}

export function skillRegistry(params) {
  return request({
    url: `${SKILLHUB_AGENT_PREFIX}/registry`,
    method: "get",
    params,
  });
}

export function skillInvokeSpec(skillUuid, params) {
  return request({
    url: `${SKILLHUB_AGENT_PREFIX}/${skillUuid}/invoke-spec`,
    method: "get",
    params,
  });
}

export function skillVersionFiles(skillUuid, version) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions/${version}/files`,
    method: "get",
  });
}

export function skillVersionReadme(skillUuid, version) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions/${version}/readme`,
    method: "get",
  });
}

export function skillVersionFileContent(skillUuid, version, path) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions/${version}/files/content`,
    method: "get",
    params: { path },
  });
}

export function submitSkillAudit(skillUuid, data) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/submit`,
    method: "post",
    data,
  });
}

export function uploadSkill(data) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/upload`,
    method: "post",
    data,
    timeout: 600000,
  });
}

export function uploadSkillVersion(skillUuid, data) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions/upload`,
    method: "post",
    data,
    timeout: 600000,
  });
}

export function setDefaultSkillVersion(skillUuid, version) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions/${version}/default`,
    method: "post",
  });
}

export function updateSkillVersionStatus(skillUuid, version, status) {
  return request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${skillUuid}/versions/${version}/status`,
    method: "post",
    params: { status },
  });
}

export function skillAuditPage(data) {
  return request({
    url: `${SKILLHUB_ADMIN_PREFIX}/page`,
    method: "post",
    data,
  });
}

export function reviewSkillAudit(skillUuid, data) {
  return request({
    url: `${SKILLHUB_ADMIN_PREFIX}/${skillUuid}/review`,
    method: "post",
    data,
  });
}

export async function getSkillVersionDownloadUrl(skillUuid, version) {
  const result = await request({
    url: `${SKILLHUB_CONSOLE_PREFIX}/${encodeURIComponent(skillUuid)}/versions/${encodeURIComponent(version)}/download-url`,
    method: "get",
    downloadAuthorization: true,
  });
  if (!result?.data?.downloadUrl) throw new Error("Download URL is missing");
  return result.data.downloadUrl;
}
